export const DATE_FORMAT = "DD/MM/YYYY HH:mm"